import { render, staticRenderFns } from "./BigPreview.vue?vue&type=template&id=196e56e6"
import script from "./BigPreview.vue?vue&type=script&lang=js"
export * from "./BigPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports